import SheetPaginationSelector from './sheet-pagination-selector';

export default SheetPaginationSelector;
